module.exports = __webpack_public_path__ + "static/media/grab_alc_singha_620_12.70b60ae8.jpg";